import { CaretDownIcon, IconButton } from '@ds/components'

import styles from './AudioHeroBottom.module.css'

type TAudioHeroBottomProps = {
    label: string
    onScrollToDetails: () => void
}

/**
 * Bottom-of-hero scroll cue to the details/comments section. Two shapes, as in audio-web: a caption
 * plus a caret button on desktop, a full-width link bar below it. Presentational — the handler is the
 * caller's.
 */
export const AudioHeroBottom = ({ label, onScrollToDetails }: TAudioHeroBottomProps) => (
    <>
        <div className={styles.bottom}>
            <span className={styles.label}>{label}</span>
            <IconButton
                Icon={CaretDownIcon}
                variant="inverse"
                aria-label={label}
                onClick={onScrollToDetails}
            />
        </div>
        <div className={styles.mobileBar}>
            <button type="button" className={styles.mobileLink} onClick={onScrollToDetails}>
                {label}
            </button>
        </div>
    </>
)
